import { IMG_BASE_URL } from './misc.js';

const IMAGE_URLS = {
    PREMIUM_LAUNCH_BADGE_GIF: `${IMG_BASE_URL}/premium-launch-banner.gif`
};
const FORM_URLS = {
    PREMIUM_LAUNCH_G_FORM: "https://docs.google.com/forms/d/e/1FAIpQLSdCM8q6QFmUJ7vBbsvnwBLnlngz8mRq3fcjTbJenBJUp--t5g/viewform"
};
const KYC_VERIFICATION_METHODS_TYPE_URL = "https://vahak-tr.s3.ap-south-1.amazonaws.com/KycVerificationType.json";

export { FORM_URLS, IMAGE_URLS, KYC_VERIFICATION_METHODS_TYPE_URL };
//# sourceMappingURL=urls.js.map
